<template>
    <button
        type="button"
        class="flex h-12 w-12 flex-none items-center justify-center rounded-full"
        :class="stateClasses"
        :disabled="disabled || busy"
        :aria-label="busy ? `Adding ${label}` : `Add ${label}`"
        :aria-busy="busy"
        @click="$emit('click')"
    >
        <svg
            v-if="busy"
            class="h-6 w-6 animate-spin"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            aria-hidden="true"
        >
            <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
            ></circle>
            <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
        </svg>
        <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            class="h-6 w-6"
            aria-hidden="true"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 4.5v15m7.5-7.5h-15"
            />
        </svg>
    </button>
</template>

<script setup>
import { computed } from 'vue'

// The round "+" used to add a row in a slide-in list. `busy` marks the row
// that is being added (spinner, announced as "Adding <label>"); `disabled`
// is for the other rows while that add is in flight.
const props = defineProps({
    label: {
        type: String,
        required: true,
    },
    busy: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
})

defineEmits(['click'])

const stateClasses = computed(() => {
    if (props.busy) {
        return 'cursor-wait bg-taupe-200 text-taupe-800'
    }

    return props.disabled
        ? 'cursor-not-allowed bg-taupe-50 text-taupe-500'
        : 'cursor-pointer bg-taupe-200 text-taupe-800 hover:bg-sky-500 hover:text-white'
})
</script>
